import {
    Dialog,
    DialogTrigger,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription
  } from "../../../components/ui/dialog";
  import { ScrollArea } from "../../../components/ui/scroll-area";
  import { Button } from "../../../components/ui/button";
  import { Badge } from "../../../components/ui/badge";
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }
  export default function DeletedContractHistoryDialog({
    deletedContracts = [],
  }:any) {
    if(!deletedContracts[0]){
        return <div></div>
    }
    return (
      <div className="pt-4 border-t ">
        <Dialog >
          <DialogTrigger asChild>
            <Button variant="outline" className="w-full">
              View Deleted Contract History ({deletedContracts.length})
            </Button>
          </DialogTrigger>
  
          <DialogContent style={{
            minWidth:460
          }} className=" tailwind-prefix ">
            <DialogHeader>
              <DialogTitle>Deleted Contract History</DialogTitle>
              <DialogDescription>
                All contracts that have been deleted
              </DialogDescription>
            </DialogHeader>
  
            <ScrollArea className="h-[500px]  w">
              {deletedContracts.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <p>No deleted contracts</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {deletedContracts.map((deletedContract:any) => (
                    <div
                      key={deletedContract.id}
                      className="border rounded p-3"
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <div className="font-semibold">
                            Contract #{deletedContract.id}
                          </div>
                          <p className="text-sm text-gray-500">
  {formatDate(new Date(deletedContract.deletedAt))}
</p>

                        </div>
  
                        <Badge
                          variant={
                            deletedContract.signatureStatus === "signed"
                              ? "default"
                              : "secondary"
                          }
                        >
                          {deletedContract.signatureStatus === "signed"
                            ? "Was Signed"
                            : "Was Pending"}
                        </Badge>
                      </div>
  
                      <div className="grid  gap-4 text-sm">
                      
  
                        <div>
                          <span className="text-gray-600">Deleted By: </span>
                          <span className="font-medium">
                            {deletedContract.deletedByFirstName +" "+ deletedContract.deletedByLastName} {`(${deletedContract.deletedByUserType})`}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </ScrollArea>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
  